module.exports = __webpack_public_path__ + "static/img/V3-1.acff46a.png";


//////////////////
// WEBPACK FOOTER
// ./static/langPack/V3/V3-1.png
// module id = N4O2
// module chunks = 1